import { IonInput, IonLabel } from '@ionic/react'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'
import Button from '../../../../components/actions/Button'
import useUser from '../../../../contexts/hooks/useUser'
import { ModalContext } from '../../../../contexts/ModalContext'
import { backendCall } from '../../../../modules/backendApi'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'

const ChangePassword: React.FC = () => {
	const { closeModal } = useContext(ModalContext)

	const { user } = useUser()

	const [currentPassword, setCurrentPassword] = useState('')
	const [newPassword, setNewPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')

	const { t } = useTranslation('pages_settings', {
		keyPrefix: 'accountManagement.changePasswordPage',
	})
	const { t: tc } = useTranslation('common')

	const onSave = async () => {
		logEvent('click-password-change-save')
		if (!user) return

		if (newPassword !== confirmPassword) return setErrorMessage(t('error'))

		try {
			setErrorMessage('')
			setSuccessMessage('')
			const result = await backendCall.users.changePassword(user.id, currentPassword, newPassword)

			if ((result as any).error) {
				setErrorMessage((result as any).message)
			} else {
				setSuccessMessage(t('success'))
			}
		} catch (error) {
			console.error('Error changing password:', error)
			setErrorMessage(t('error'))
		}
	}

	return (
		<PageWrapper page='changePassword' appBarOptions={{ backPath: '/settings/account-management' }}>
			{errorMessage && (
				<IonLabel className='text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-1 mb-4'>
					{errorMessage}
				</IonLabel>
			)}
			{successMessage && (
				<IonLabel className='text-sm text-green-700 bg-green-50 border border-green-100 rounded-md px-3 py-1 mb-4'>
					{successMessage}
				</IonLabel>
			)}
			{!successMessage && (
				<>
					<div className='input-container'>
						<IonLabel className='text-text-dark dark:text-white'>{t('current')}</IonLabel>
						<IonInput
							value={currentPassword}
							onIonInput={e => setCurrentPassword(e.detail.value!)}
							type='password'
							className='border border-brand-primary-100-light dark:border-brand-primary-100-dark text-text-dark dark:text-white'
						/>
					</div>
					<div className='input-container'>
						<IonLabel className='text-text-dark dark:text-white'>{t('new')}</IonLabel>
						<IonInput
							value={newPassword}
							onIonInput={e => setNewPassword(e.detail.value!)}
							type='password'
							className='border border-brand-primary-100-light dark:border-brand-primary-100-dark text-text-dark dark:text-white'
						/>
					</div>
					<div className='input-container'>
						<IonLabel className='text-text-dark dark:text-white'>{t('confirm')}</IonLabel>
						<IonInput
							value={confirmPassword}
							onIonInput={e => setConfirmPassword(e.detail.value!)}
							type='password'
							className='border border-brand-primary-100-light dark:border-brand-primary-100-dark text-text-dark dark:text-white'
						/>
					</div>
				</>
			)}
			<div className='flex flex-row gap-4'>
				<Button className='w-full rounded-full bg-highlight' onClick={closeModal}>
					{successMessage ? tc('valmis') : tc('peruuta')}
				</Button>
				{!successMessage && (
					<Button
						className='w-full rounded-full bg-brand-primary-100-light dark:bg-brand-primary-100-dark'
						onClick={onSave}
					>
						{tc('tallenna')}
					</Button>
				)}
			</div>
		</PageWrapper>
	)
}

export default ChangePassword
